import type { ActivityModule } from '../../core/activity';
import { mountEnumerate } from './ui';
import levelsData from './levels.json';
import './style.css';

export const enumerate: ActivityModule = {
  id: 'enumerate',
  title: 'Conte os frutos',
  description: 'Quantos frutos de cada tipo tem? Arraste pra organizar e digite o total.',
  ageMin: 4,
  ageMax: 7,
  difficulty: 2,
  iconPath: 'assets/gcompris-AGPL/enumerate/icon.svg',
  category: 'numeracao',
  totalLevels: levelsData.levels.length,
  mount: mountEnumerate,
};
